import { Injectable } from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';

@Injectable({
    providedIn: 'root',
})
export class SessionDetailsService {
    constructor() { }

    get adminDetails() {
        let admin = localStorage.getItem('adminUser') || null;
        if (admin) {
            admin = JSON.parse(admin);
            return {
                adminId: admin['id'],
            };
        }
    }
}
